import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container contact-layout" }
const _hoisted_3 = { class: "detail-list" }
const _hoisted_4 = { href: "tel:+493012345670" }
const _hoisted_5 = { href: "mailto:praxis@zahnzentrum-demo.de" }
const _hoisted_6 = { class: "hours-card" }
const _hoisted_7 = { class: "section form-section" }
const _hoisted_8 = { class: "container form-card" }
const _hoisted_9 = { class: "form-intro" }
const _hoisted_10 = { class: "form-trust" }
const _hoisted_11 = { class: "field-row" }
const _hoisted_12 = { class: "privacy-check" }
const _hoisted_13 = {
  key: 0,
  class: "form-success"
}
const _hoisted_14 = {
  key: 1,
  class: "form-error"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "map-placeholder" }

import {ref} from 'vue'; import {CheckCircle2,Clock3,Mail,MapPin,Phone,Send} from 'lucide-vue-next'

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const form=ref({name:'',email:'',phone:'',message:'',privacy:false}); const sending=ref(false); const success=ref(false); const error=ref('')
async function submit(){sending.value=true;error.value='';success.value=false;await new Promise(resolve=>setTimeout(resolve,700));success.value=true;sending.value=false;form.value={name:'',email:'',phone:'',message:'',privacy:false}}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[27] || (_cache[27] = _createElementVNode("section", { class: "page-hero" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("span", { class: "eyebrow" }, "Kontakt & Anfahrt"),
        _createElementVNode("h1", null, [
          _createTextVNode("Wir sind gerne"),
          _createElementVNode("br"),
          _createElementVNode("em", null, "für Sie da.")
        ]),
        _createElementVNode("p", null, "Vereinbaren Sie Ihren Termin telefonisch, per E-Mail oder direkt über unser Kontaktformular.")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "eyebrow" }, "Terminvereinbarung", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "standalone-title" }, "So erreichen Sie uns", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", _hoisted_4, [
              _createVNode(_unref(Phone)),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, [
                _createElementVNode("small", null, "Telefon"),
                _createElementVNode("strong", null, "030 12345670")
              ], -1))
            ]),
            _createElementVNode("a", _hoisted_5, [
              _createVNode(_unref(Mail)),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, [
                _createElementVNode("small", null, "E-Mail"),
                _createElementVNode("strong", null, [
                  _createTextVNode("praxis@zahnzentrum-"),
                  _createElementVNode("br"),
                  _createTextVNode("demo.de")
                ])
              ], -1))
            ]),
            _createElementVNode("div", null, [
              _createVNode(_unref(MapPin)),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, [
                _createElementVNode("small", null, "Adresse"),
                _createElementVNode("strong", null, [
                  _createTextVNode("Parkallee 12"),
                  _createElementVNode("br"),
                  _createTextVNode("12345 Musterstadt")
                ])
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(Clock3)),
          _cache[10] || (_cache[10] = _createStaticVNode("<h3>Öffnungszeiten</h3><dl><div><dt>Montag</dt><dd>08:00 – 18:00</dd></div><div><dt>Dienstag</dt><dd>08:00 – 18:00</dd></div><div><dt>Mittwoch</dt><dd>08:00 – 18:00</dd></div><div><dt>Donnerstag</dt><dd>08:00 – 18:00</dd></div><div><dt>Freitag</dt><dd>08:00 – 14:00</dd></div></dl><p>Telefonzeiten Mo–Do 09:00–13:00 und 14:00–18:00 Uhr, Freitag 09:00–13:00 Uhr.</p>", 3))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "eyebrow" }, "Schreiben Sie uns", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("h2", null, "Wie können wir Ihnen helfen?", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("p", null, "Füllen Sie das Formular aus. Wir melden uns schnellstmöglich persönlich bei Ihnen zurück.", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", null, [
              _createVNode(_unref(CheckCircle2)),
              _cache[11] || (_cache[11] = _createTextVNode(" Vertrauliche Übermittlung", -1))
            ]),
            _createElementVNode("span", null, [
              _createVNode(_unref(CheckCircle2)),
              _cache[12] || (_cache[12] = _createTextVNode(" Persönliche Rückmeldung", -1))
            ])
          ])
        ]),
        _createElementVNode("form", {
          class: "contact-form",
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", null, [
              _cache[16] || (_cache[16] = _createElementVNode("span", null, "Name *", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                required: "",
                autocomplete: "name",
                placeholder: "Vor- und Nachname"
              }, null, 512), [
                [_vModelText, form.value.name]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[17] || (_cache[17] = _createElementVNode("span", null, "E-Mail *", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.email) = $event)),
                required: "",
                type: "email",
                autocomplete: "email",
                placeholder: "name@beispiel.de"
              }, null, 512), [
                [_vModelText, form.value.email]
              ])
            ])
          ]),
          _createElementVNode("label", null, [
            _cache[18] || (_cache[18] = _createElementVNode("span", null, "Telefon", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.phone) = $event)),
              type: "tel",
              autocomplete: "tel",
              placeholder: "Für einen Rückruf"
            }, null, 512), [
              [_vModelText, form.value.phone]
            ])
          ]),
          _createElementVNode("label", null, [
            _cache[19] || (_cache[19] = _createElementVNode("span", null, "Ihre Nachricht *", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.message) = $event)),
              required: "",
              rows: "6",
              placeholder: "Wie können wir Ihnen helfen?"
            }, null, 512), [
              [_vModelText, form.value.message]
            ])
          ]),
          _createElementVNode("label", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.privacy) = $event)),
              required: "",
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, form.value.privacy]
            ]),
            _createElementVNode("span", null, [
              _cache[21] || (_cache[21] = _createTextVNode("Ich habe die ", -1)),
              _createVNode(_component_router_link, { to: "/datenschutz" }, {
                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                  _createTextVNode("Datenschutzerklärung", -1)
                ]))]),
                _: 1
              }),
              _cache[22] || (_cache[22] = _createTextVNode(" gelesen und stimme der Verarbeitung meiner Angaben zu.", -1))
            ])
          ]),
          (success.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                _createVNode(_unref(CheckCircle2)),
                _cache[23] || (_cache[23] = _createTextVNode(" Vielen Dank! Ihre Nachricht wurde übermittelt.", -1))
              ]))
            : _createCommentVNode("", true),
          (error.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "button primary",
            type: "submit",
            disabled: sending.value
          }, [
            _createVNode(_unref(Send)),
            _createTextVNode(" " + _toDisplayString(sending.value?'Wird gesendet …':'Nachricht senden'), 1)
          ], 8, _hoisted_15)
        ], 32)
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _createElementVNode("div", null, [
        _createVNode(_unref(MapPin)),
        _cache[24] || (_cache[24] = _createElementVNode("strong", null, "Praxis am Stadtpark", -1)),
        _cache[25] || (_cache[25] = _createElementVNode("span", null, "Parkallee 12 · 12345 Musterstadt", -1)),
        _cache[26] || (_cache[26] = _createElementVNode("a", {
          target: "_blank",
          rel: "noopener",
          href: "https://www.google.com/maps/search/?api=1&query=Parkallee+12+12345+Musterstadt"
        }, "Route planen", -1))
      ])
    ])
  ]))
}
}

})